export default {
  'menu.more-blocks': '更多区块',
  'menu.admin': '管理页',
  'menu.admin.sub-page': '二级管理页',
  'menu.login': '登录',
  'menu.register': '注册',
  'menu.register-result': '注册结果',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': '分析页',
  'menu.dashboard.monitor': '监控页',
  'menu.dashboard.workplace': '工作台',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': '表单页',
  'menu.form.basic-form': '基础表单',
  'menu.form.step-form': '分步表单',
  'menu.form.step-form.info': '分步表单（填写转账信息）',
  'menu.form.step-form.confirm': '分步表单（确认转账信息）',
  'menu.form.step-form.result': '分步表单（完成）',
  'menu.form.advanced-form': '高级表单',
  'menu.list': '列表页',
  'menu.list.table-list': '查询表格',
  'menu.list.basic-list': '标准列表',
  'menu.list.card-list': '卡片列表',
  'menu.list.search-list': '搜索列表',
  'menu.list.search-list.articles': '搜索列表（文章）',
  'menu.list.search-list.projects': '搜索列表（项目）',
  'menu.list.search-list.applications': '搜索列表（应用）',
  'menu.profile': '详情页',
  'menu.profile.basic': '基础详情页',
  'menu.profile.advanced': '高级详情页',
  'menu.result': '结果页',
  'menu.result.success': '成功页',
  'menu.result.fail': '失败页',
  'menu.exception': '异常页',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',
  'menu.account': '个人页',
  'menu.account.center': '个人中心',
  'menu.account.settings': '个人设置',
  'menu.account.trigger': '触发报错',
  'menu.account.logout': '退出登录',
  'menu.editor': '图形编辑器',
  'menu.editor.flow': '流程编辑器',
  'menu.editor.mind': '脑图编辑器',
  'menu.editor.koni': '拓扑编辑器',
  'menu.accountSettings': '用户设置',
  'menu.shopLogin': '商户登录',
  'menu.shopWelcome': '商户首页',
  'menu.shopSettings': '商户设置',
  'menu.stat': '报表统计',
  'menu.stat.statDashboard': '数据统计',
  'menu.shopManage': '商户管理',
  'menu.shopManage.shopList': '商户列表',
  'menu.shopManage.shopOperator': '商户操作员',
  'menu.shopManage.shopLog': '商户日志',
  'menu.goodManage': '商品管理',
  'menu.goodManage.goodCategory': '商品分类',
  'menu.goodManage.goodsList': '商品列表',
  'menu.orderManage': '订单管理',
  'menu.orderManage.orderList': '订单列表',
  'menu.financial': '财务管理',
  'menu.financial.userPay': '支付记录',
  'menu.financial.userRefund': '退款记录',
  'menu.financial.userButieLog': '补贴变动日志',
  'menu.admManage': '系统管理',
  'menu.admManage.admUser': '管理员',
  'menu.admManage.admRole': '角色管理',
  'menu.admManage.admRight': '权限资源',
  'menu.admManage.admLog': '系统日志',
  'menu.admManage.admDic': '数据字典',
  'menu.userManage': '用户管理',
  'menu.userManage.user': '用户列表',
  'menu.userManage.applyManage': '申请管理',
};
